module.exports = __webpack_public_path__ + "static/media/respire-white.a49f6977.png";